.button {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  min-height: 64px;
  min-width: 96px;
  padding: 12px 14px;
  border: 2px solid var(--tuna-palette-divider);
  border-radius: var(--tuna-shape-radius-md);
  background: var(--tuna-palette-background-paper);
  cursor: pointer;
  transition:
    background 120ms ease,
    border-color 120ms ease;
}

.button:hover:not(:disabled) {
  border-color: var(--tuna-palette-primary-main);
  background: var(--tuna-palette-action-hover);
}

.button:disabled {
  cursor: not-allowed;
}

/* The success/error -light fills are light in both themes, so the text on them is dark in both: the inherited
 * white read 2.01:1 / 2.99:1 in dark (GH #2529). grey-900 is the same in both themes. */
.correct {
  border-color: var(--tuna-palette-success-main);
  background: var(--tuna-palette-success-light);
  color: var(--tuna-palette-grey-900);
}

.incorrect {
  border-color: var(--tuna-palette-error-main);
  background: var(--tuna-palette-error-light);
  color: var(--tuna-palette-grey-900);
}

.correct .shortTag,
.incorrect .shortTag {
  color: inherit;
}

.dimmed {
  opacity: 0.45;
}

.longName {
  font-weight: 600;
  font-size: var(--tuna-typography-fontSize-md);
}

.shortTag {
  font-size: var(--tuna-typography-fontSize-xs);
  color: var(--tuna-palette-text-secondary);
}
